import React from 'react';
import { FaShareAlt } from "react-icons/fa";
import { RWebShare } from 'react-web-share';

const Share = () => {
    return (
        <RWebShare
            data={{
                url: "https://mainuddinsde.web.app/",
                title: "Mainuddin",
            }}
            onClick={() => console.log("Share Button Clicked!!")}
        >
            <div className="bg-gradient-to-l from-cyan-500 to-blue-500 flex flex-col items-center 
                justify-center top-[84%] right-2 fixed w-12 h-12 rounded-full text-gray-300 cursor-pointer
                shadow-md"
            >
                <FaShareAlt size={20} className="" />
            </div>
        </RWebShare>
    )
}

export default Share;